<template>
  <div>
    <b-row>
      <b-col cols="12" md="9">
        <b-form-group label="Título:">
          <b-form-input
            v-model="pauta.titulo"
            placeholder="Título"
            :state="validateState('titulo')"
          ></b-form-input>
          <b-form-invalid-feedback
            >Título é um campo obrigatório.</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col cols="12" md="3">
        <b-form-group label="Tipo:">
          <b-form-select
            v-model="pauta.tipo"
            :options="[
              { value: 'deliberativa', text: 'Deliberativa' },
              { value: 'informativa', text: 'informativa' },
            ]"
            :state="validateState('tipo')"
          ></b-form-select>
          <b-form-invalid-feedback
            >Tipo é um campo obrigatório.</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="pauta.tipo == 'deliberativa'">
      <b-col cols="12" md="3">
        <b-form-group label="Resultado da Deliberação:">
          <b-form-radio
            v-model="votacao"
            value="aprovado_unanimidade"
            name="check-votacao"
          >
            Aprovada por Unanimidade
          </b-form-radio>

          <b-form-radio
            v-model="votacao"
            value="rejeitado_unanimidade"
            name="check-votacao"
          >
            Rejeitado por Unanimidade
          </b-form-radio>

          <b-form-radio v-model="votacao" :value="null" name="check-votacao">
            Detalhar Votação
          </b-form-radio>
        </b-form-group>
      </b-col>

      <b-col cols="12" md="9" v-if="votacao === null">
        <b-row>
          <b-col>
            <b-form-group label="Votos a favor:">
              <b-form-input
                v-model="pauta.votos_favor"
                placeholder="a favor"
                type="number"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Votos contra:">
              <b-form-input
                v-model="pauta.votos_contra"
                placeholder="contra"
                type="number"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Abstenções:">
              <b-form-input
                v-model="pauta.abstencoes"
                placeholder="abstenções"
                type="number"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-form-group label="Descrição:">
      <Editor
        v-model="pauta.descricao"
        placeholder="Insira uma descrição para o pauta"
      />
    </b-form-group>
  </div>
</template>

<script>
import Editor from "@/components/Form/Editor.vue";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
  mixins: [validationMixin],
  components: { Editor },
  props: {},
  data: () => ({}),
  validations: {
    pauta: {
      titulo: {
        required,
      },
      tipo: {
        required,
      },
    },
  },
  computed: {
    ...mapState("pautas", ["pauta"]),
    votacao: {
      set(value) {
        this.pauta.aprovado_unanimidade = false;
        this.pauta.rejeitado_unanimidade = false;

        if (value == "aprovado_unanimidade") {
          this.pauta.aprovado_unanimidade = true;
        } else if (value == "rejeitado_unanimidade") {
          this.pauta.rejeitado_unanimidade = true;
        }
      },
      get() {
        let response = null;
        if (this.pauta.aprovado_unanimidade) {
          response = "aprovado_unanimidade";
        } else if (this.pauta.rejeitado_unanimidade) {
          response = "rejeitado_unanimidade";
        }
        return response;
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.pauta[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.pauta.$touch();
      return !this.$v.pauta.$anyError;
    },
  },
  created() {},
};
</script>
